import { styled } from '@mui/material/styles'
import { alpha, Box } from '@mui/material'

export const GeolocationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginRight: 24,
  marginTop: 80,
}))

export const GeolocationIcon = styled(Box)(({ theme }) => ({
  color: '#464646',
  cursor: 'pointer',
  backgroundColor: 'white',
  minHeight: '40px',
  minWidth: '40px',
  maxHeight: '40px',
  maxWidth: '40px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: `0 12px 16px -8px ${alpha(
    theme.palette.common.black,
    0.24,
  )}`,
  '&:hover': {
    color: theme.palette.primary.main,
  },
}))



export const SearchContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 24,
  marginTop: 80,
}))